import { ActivityLog } from '@models/ActivityLog'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import {
  ActivityLogFilter,
  initialQuery,
} from '@supplement-bacon/sb-table-filters'
import { ACTIVITY_LOGS_URL } from '@utils/urls'

const fetchActivityLogs = (
  filters: ActivityLogFilter,
  page: number = 1,
  pageSize: number = 25
) =>
  SBAPI.FetchPaginated<ActivityLog[]>(ACTIVITY_LOGS_URL, {
    ...initialQuery,
    pagination: { current: page, pageSize },
    filters: {
      log: filters,
    },
  })

/**
 * Logs of a whole log name, for entries that hang off a global record rather than
 * off an entity the page knows the id of — the membership demo booklet, for one,
 * whose subject is a row of the settings table.
 */
const fetchActivityLogsByLogName = (
  logNames: string[],
  page: number = 1,
  pageSize: number = 25
) =>
  SBAPI.FetchPaginated<ActivityLog[]>(ACTIVITY_LOGS_URL, {
    ...initialQuery,
    pagination: { current: page, pageSize },
    filters: {
      logName: logNames,
    },
  })

export { fetchActivityLogs, fetchActivityLogsByLogName }
